import {
    mobile,
    backend,
    creator,
    web,
    javascript,
    typescript,
    html,
    css,
    reactjs,
    java,
    cpp,
    python,
    tailwind,
    nodejs,
    mongodb,
    git,
    figma,
    docker,
    meta,
    starbucks,
    tesla,
    shopify,
    carrent,
    jobit,
    tripguide,
    threejs,
  } from "../assets/index";

  // import { AiOutlineShoppingCart } from "../sanity/node_modules/react-icons/ai"
  
  const navLinks = [
    {
      id: "about",
      title: "About",
    },
    {
      id: "work",
      title: "Work",
    },
    {
      id: "tech",
      title: "Skills",
    },
    {
      id: "projects",
      title: "Projects",
    },
    {
      id: "contact",
      title: "Contact",
    },
  ];
  
  const services = [
    {
      title: "Software Engineer",
      icon: web,
    },
    {
      title: "Full Stack Developer",
      icon: mobile,
    },
    {
      title: "Data Scientist",
      icon: creator,
    },
    {
      title: "DevOps Engineer",
      icon: backend,
    },
  ];
  
  const technologies = [
    {
      name: "Java",
      icon: java,
    },
    {
      name: "Python",
      icon: python,
    },
    {
      name: "C ++",
      icon: cpp,
    },
    {
      name: "HTML 5",
      icon: html,
    },
    {
      name: "CSS 3",
      icon: css,
    },
    {
      name: "JavaScript",
      icon: javascript,
    },
    {
      name: "TypeScript",
      icon: typescript,
    },
    {
      name: "React JS",
      icon: reactjs,
    },
    {
      name: "Tailwind CSS",
      icon: tailwind,
    },
    {
      name: "Node JS",
      icon: nodejs,
    },
    {
      name: "MongoDB",
      icon: mongodb,
    },
    {
      name: "git",
      icon: git,
    },
    // {
    //   name: "Three JS",
    //   icon: threejs,
    // },
    // {
    //   name: "figma",
    //   icon: figma,
    // },
    {
      name: "docker",
      icon: docker,
    },
  ];
  
  const experiences = [
    {
      title: "Fullstack Web Developer",
      company_name: "VoidWalker Media • Delhi",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Jun 2025 – Present",
      points: [
        "Built AI-first backend architectures using Vertex AI and Gemini Flash-Lite for multi-agent workflows",
        "Developed microservice infrastructure with secure authentication and subscription systems",
        "Led CI/CD automation across Google Cloud and Vercel, improving system reliability",
      ],
    },
    {
      title: "Freelance Web Developer",
      company_name: "Upwork • Remote",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Oct 2024 – Jun 2025",
      points: [
        "Built responsive websites using React and Node.js with optimized performance",
        "Managed multiple projects for international clients with clear communication",
        "Implemented modern practices including responsive design and SEO optimization",
      ],
    },
    
    {
      title: "Mern Developer",
      company_name: "The Shubham Group",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Aug 2024 - Nov 2024",
      points: [
        "Optimized 7+ real estate websites focusing on visual appeal and technical performance",
        "Implemented responsive design principles ensuring seamless user experience",
        "Improved website loading speed through technical optimization",
      ],
    },
    {
      title: "Web Developer - MERN Stack",
      company_name: "Encryptix",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Feb 2023 - Aug 2024",
      points: [
        "Built HR management system for tracking employee data and performance",
        "Developed booking platform for Henna services catering to weddings and events",
      ],
    },
    {
      title: "Java Backend Developer",
      company_name: "CodSoft",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Sep 2022 - Feb 2023",
      points: [
        "Built student course registration database with detailed information storage",
        "Created command-line application for solving mathematical problems",
        "Developed multiple choice quiz game with timed functionality",
      ],
    },
    {
      title: "Social Media Marketing Manager",
      company_name: "Sociara",
      icon: starbucks,
      iconBg: "#FFFFFF",
      date: "Jan 2022 - Aug 2022",
      points: [
        "Managed social media strategy for 3+ lifestyle and wellness businesses",
        "Created engaging visual content aligned with brand identity",
        "Executed campaigns to boost brand awareness and engagement",
      ],
    },
  ];
  
  const testimonials = [
    {
      testimonial:
        "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
      name: "Sara Lee",
      designation: "CFO",
      company: "Acme Co",
      image: "https://randomuser.me/api/portraits/women/4.jpg",
    },
    {
      testimonial:
        "I've never met a web developer who truly cares about their clients' success like Rick does.",
      name: "Chris Brown",
      designation: "COO",
      company: "DEF Corp",
      image: "https://randomuser.me/api/portraits/men/5.jpg",
    },
    {
      testimonial:
        "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
      name: "Lisa Wang",
      designation: "CTO",
      company: "456 Enterprises",
      image: "https://randomuser.me/api/portraits/women/6.jpg",
    },
  ];
  
  const projects = [
    {
      name: "AI-Headshot Generator",
      description:
        " Developed an AI-driven app, orchestrating the training of AI data models for transforming sample images into professional headshots. Integrated secure authentication, with a user-friendly and data-protected experience.",
      tags: [
        {
          name: "next.js",
          color: "blue-text-gradient",
        },
        {
          name: "Leap AI",
          color: "green-text-gradient",
        },
        {
          name: "vercel",
          color: "pink-text-gradient",
        },
        {
          name: "supabase",
          color: "black-text-gradient",
        },
      ],
      image: carrent,
      source_code_link: "https://ai-headshots-gen.vercel.app/",
    },
    {
      name: "Job IT",
      description:
        "Web application that enables users to search for job openings, view estimated salary ranges for positions, and locate available jobs based on their current location.",
      tags: [
        {
          name: "react",
          color: "blue-text-gradient",
        },
        {
          name: "tailwind-css",
          color: "green-text-gradient",
        },
        {
          name: "shadcn-ui",
          color: "pink-text-gradient",
        },
      ],
      image: jobit,
      source_code_link: "https://jobit-one.vercel.app/",
    },
    {
      name: "Model Earth",
      description:
        "Model Earth is a platform integrates with major e-commerce and shipping systems, aiming to simplify user experience while maximizing positive environmental outcomes.",
      tags: [
        {
          name: "python",
          color: "blue-text-gradient",
        },
        {
          name: "jupyter",
          color: "green-text-gradient",
        },
        {
          name: "api",
          color: "pink-text-gradient",
        },
      ],
      image: tripguide,
      source_code_link: "https://model.earth/community/",
    },
    
    // {
    //   name: "Open Foot Print",
    //   description:
    //     "The Open Footprint Project by Model Earth focuses on creating Environmental Product Declarations (EPDs) and footprint profiles for communities, companies, products, and individuals. They provide tools for lifecycle assessment and environmental impact analysis, helping communities and businesses make data-driven decisions to reduce their ecological footprint.",
    //   tags: [
    //     {
    //       name: "nextjs",
    //       color: "blue-text-gradient",
    //     },
    //     {
    //       name: "python",
    //       color: "green-text-gradient",
    //     },
    //     {
    //       name: "supabase",
    //       color: "pink-text-gradient",
    //     },
    //   ],
    //   image: carrent,
    //   source_code_link: "https://github.com/ModelEarth/OpenFootprint/",
    // },
  ];
  
  export { services, technologies, experiences, testimonials, projects };